import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '../../../../../../infra/i18n';
import { PromoCodeSection } from './promo-code-section';
import { usePromoCodes } from '../../campaign-configuration/promo-code/hooks/use-promo-codes';
import { getPromoCodeExpirationDate, renderPromoCodeValue } from '../../../../components/promo-code-select/helpers';
import { useReduxSelector } from '../../../../../../infra/redux-bridge';
import { SHOP_CURRENCY } from '../../../../../../../app/main/shops/constants';
import { useEditableField } from '../../../hooks/use-editable-field';
export var PromoCodeSectionContainer = function () {
    var promoIdField = useEditableField('promoId').field;
    var promoCodes = usePromoCodes().promoCodes;
    var reduxCurrency = useReduxSelector('auth.currency');
    var currency = reduxCurrency || SHOP_CURRENCY.usd;
    var selectedPromoCode = promoCodes.find(function (el) { return el.id === promoIdField.value; });
    if (!selectedPromoCode) {
        return null;
    }
    var expirationDate = getPromoCodeExpirationDate(selectedPromoCode);
    var expirationMessage = expirationDate
        ? t('engage:campaign_builder.promo_code.use_by', { expirationDate: expirationDate })
        : t('engage:campaign_builder.promo_code.no_expiry_date');
    var promoCodeValue = renderPromoCodeValue(selectedPromoCode, currency);
    return (_jsx(PromoCodeSection, { code: selectedPromoCode.code, expirationMessage: expirationMessage, promoCodeValue: promoCodeValue }));
};
